// Captura os parametros de UTM da URL e guarda pra conseguir mandar junto
// no cadastro, mesmo que a pessoa navegue por varias paginas internas
// antes de criar a conta.
//
// Como o site usa HashRouter, o UTM pode vir em dois lugares:
//   antes do #: worsheep.netlify.app/?utm_source=x#/
//   depois do #: worsheep.netlify.app/#/cadastro?plano=Individual&utm_source=x
// Os dois sao lidos.

const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

const STORAGE_KEY = 'YogaCO@UtmParams';

const getHashQuery = () => {
  const hash = window.location.hash;
  const queryStart = hash.indexOf('?');
  return queryStart === -1 ? '' : hash.slice(queryStart);
};

export const captureUtmParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const hashParams = new URLSearchParams(getHashQuery());
  const utmData = {};

  UTM_KEYS.forEach((key) => {
    const value = hashParams.get(key) || searchParams.get(key);
    if (value) utmData[key] = value;
  });

  if (Object.keys(utmData).length > 0) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(utmData));
  }
};

export const getUtmParams = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    return {};
  }
};
